<div class="movingText">
    <span>{{text}}</span>
</div>


